import { Box } from "@mui/system";
import {
  MenuItem,
  Pagination,
  PaginationItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { PAGE_SIZES } from "utils/constants/constant";
import ArrowBackIcon from "components/ArrowBackIcon";
import ArrowForwardIcon from "components/ArrowForwardIcon";
import { getPaginationDetailText } from "utils/helper";

interface ICustomPaginationProps {
  handleChange: (event: SelectChangeEvent) => void;
  page: string;
  pageNo: number;
  onPageChange: (event: React.ChangeEvent<unknown>, value: number) => void;
  listMeta: any;
}

const CustomPagination: React.FC<ICustomPaginationProps> = ({
  handleChange,
  page,
  pageNo,
  onPageChange,
  listMeta,
}) => {
  return (
    <>
      <Box className="custom-pagination">
        <Box className="custom-rowperpage">
          <Typography variant="body2" component="span">
            Entries per page:
          </Typography>
          <Select
            id="pagination-select"
            value={page}
            onChange={handleChange}
            MenuProps={{
              className: "pagination-menu",
            }}
          >
            {PAGE_SIZES?.map((pageSize) => (
              <MenuItem
                key={pageSize.value}
                value={pageSize.value}
                selected={pageSize?.selected}
              >
                {pageSize.label}
              </MenuItem>
            ))}
          </Select>
          <Typography variant="body2" component="span">
            {getPaginationDetailText(listMeta, pageNo, page)}
          </Typography>{" "}
        </Box>
        <Pagination
          count={listMeta?.totalPages}
          variant="outlined"
          shape="rounded"
          page={pageNo}
          onChange={onPageChange}
          renderItem={(item) => (
            <PaginationItem
              slots={{
                previous: ArrowBackIcon,
                next: ArrowForwardIcon,
              }}
              {...item}
            />
          )}
        />
      </Box>
    </>
  );
};
export default CustomPagination;
